import { getUserData } from "../../../global/hooks/getUserRole";
export const DeviceProductionItemsInfoColumns = () => {
  const loggedInUser = getUserData();
  const isSystemUser = [1, 2, 3].includes(loggedInUser?.role_value);

  return [
    {
      title: "No",
      dataIndex: "DeviceNo",
      key: "DeviceNo",
      hidden: !isSystemUser,
    },
    {
      title: "Device Name",
      dataIndex: "DeviceName",
      key: "DeviceName",
    },
    {
      title: "Description",
      dataIndex: "DeviceDesc",
      key: "DeviceDesc",
    },
    {
      title: "OEM",
      dataIndex: "OemNo",
      key: "OemNo",
    },
    {
      title: "Dealer",
      dataIndex: "DealerNo",
      key: "DealerNo",
    },
    {
      title: "Customer",
      dataIndex: "CustomerNo",
      key: "CustomerNo",
    },
    {
      title: "Node Type",
      dataIndex: "NodeType",
      key: "NodeType",
    },
    {
      title: "Site Type",
      dataIndex: "SiteType",
      key: "SiteType",
    },
    {
      title: "MAC",
      dataIndex: "Mac",
      key: "Mac",
    },
    {
      title: "Product",
      dataIndex: "Product",
      key: "Product",
    },
    {
      title: "Model",
      dataIndex: "Model",
      key: "Model",
    },
    {
      title: "Type",
      dataIndex: "Type",
      key: "Type",
    },
  ];
};
